import React from 'react';

const Card = (props) => {
  const { children, isPaddingless, style } = props;
  return <div className={`card notification ${isPaddingless ? 'is-paddingless' : ''}`} style={{ width: '100%', ...style }}>
    {children}
  </div>
}

export default Card;